var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.params.classes,
      attrs: {
        id: _vm.id,
        tabindex: "0",
        role: "button",
        "data-toggle": "popover",
        "data-placement": _vm.params.position,
        "data-trigger": "focus",
        title: _vm.params.title,
        "data-content": _vm.params.data_content
      }
    },
    [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v(_vm._s(_vm.params.icon))
      ]),
      _vm._v("\n    " + _vm._s(_vm.params.button_text))
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c2ff94e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2ff94e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/PopOver.vue
// module id = 274
// module chunks = 0